import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem("anv_cookie_ack")) setShow(true);
    } catch {
      setShow(true);
    }
  }, []);

  const accept = () => {
    try { localStorage.setItem("anv_cookie_ack", "1"); } catch {}
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className="fixed bottom-4 inset-x-4 md:inset-x-auto md:right-6 md:max-w-md z-50 bg-[#121214] border border-white/10 rounded-2xl p-5 shadow-2xl"
      data-testid="cookie-banner"
    >
      <div className="flex items-start gap-3">
        <Cookie className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-0.5" strokeWidth={1.5} />
        <div className="text-sm text-zinc-300 leading-relaxed">
          Usamos únicamente <strong className="text-white">cookies técnicas propias</strong> necesarias para el funcionamiento de la web y del área privada. No usamos cookies analíticas ni publicitarias.{" "}
          <Link to="/cookies" className="text-[#D4AF37] hover:underline">Más información</Link>.
        </div>
      </div>
      <div className="flex justify-end mt-4">
        <button
          onClick={accept}
          data-testid="cookie-accept"
          className="px-5 py-2 rounded-full bg-[#D4AF37] text-black text-sm font-medium hover:bg-[#FDE047] transition-colors"
        >
          Entendido
        </button>
      </div>
    </div>
  );
}
